import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';


class Pagination extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          data: [],
          offset: 0,
        };

        this.handlePageClick = this.handlePageClick.bind(this);
      }

    handlePageClick(data) {
        let selected = data.selected;
        // let offset = Math.ceil(selected * this.props.perPage);
        //
        // this.setState({ offset: offset });

        const {onClickPagination} = this.props;
        if (onClickPagination) {
            onClickPagination(selected);
        }
    };

    render() {
        return (
          <div>
            <ReactPaginate
                breakClassName="break-me"
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-number"
                activeClassName="p-n-active"
                previousLabel="<"
                nextLabel=">"
                breakLabel="..."
                pageRangeDisplayed={($(window).width() > 997) ? 2 : 1}
                marginPagesDisplayed={($(window).width() > 997) ? 2 : 1}
                pageCount={this.props.pageCount}
                onPageChange={this.handlePageClick}
                initialPage={this.props.config?.pagNum}
            />
          </div>
        );
      }
}

export default Pagination;